import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import ReturnDate from './ReturnDate';
import { getReturnStatus } from '../../../utils/order-details/OrderDetailsUtils';
export var ReturnStatus = function (_a) {
    var fg = _a.fg, variant = _a.variant;
    var _b = getReturnStatus(fg), isInitiatedReturn = _b.isInitiatedReturn, isInProgressReturn = _b.isInProgressReturn;
    return (React.createElement("div", { className: "flex flex-col sui-mb-[16px] ".concat(variant === 'card' ? '' : 'sui-min-w-[260px]') },
        React.createElement(ReturnDate, { fg: fg }),
        isInitiatedReturn && (React.createElement(Badge, { variant: "subtle", style: { marginTop: '8px' }, size: "small" }, "Initiated")),
        isInProgressReturn && (React.createElement(Badge, { variant: "subtle", style: { marginTop: '8px' }, size: "small" }, "Processing"))));
};
